/* cf-gallery.js — Comfortfusse
   1) Renge gore galeri filtreleme  (veri: snippets/cf-color-media.liquid)
   2) Masaustunde dikey kucuk resim seridi + tek buyuk gorsel

   v4: kucuk resimler artik Shopify CDN'den width=200 ile isteniyor.
       Tema tembel yukleme icin src'yi width=20 basiyordu -> bulanik cikiyordu.

   Veri: <script type="application/json" id="CFColorMedia-{section_id}">
     [0] varyant id dizisi (string)
     [1] her varyantin renk indeksi (-1 = eslesmedi)
     [2] renk indeksi -> medya anahtari dizisi ("{section_id}-{media_id}")
     [3] kodsuz medya anahtarlari (DAIMA gosterilir)

   Tema notlari (assets/product.js):
   - sliderItemsToShow zaten clientWidth>0 ile suzuluyor -> gizli slaytlar
     sayac/prev-next disinda kaliyor.
   - ProductSlider'in MutationObserver'i sadece KENDI class'ini ve dogrudan
     cocuk ekleme/cikarmasini izliyor -> inline style degisikliklerimiz guvenli.
   - Lightbox (photoswipe) listesi bir kez kuruluyor; bu dosya ona dokunmuyor.
*/
(function () {
  var TICK_MS = 400;
  var DESKTOP = '(min-width: 1069px)';
  var THUMB_W = 200;
  var JSON_PREFIX = 'CFColorMedia-';
  var SLIDE_SEL = '.product-images__slide';

  var cacheText = null, cacheVal = null;
  var current = null;

  function getData() {
    var node = document.querySelector('script[id^="' + JSON_PREFIX + '"]');
    if (!node) return null;
    if (node.textContent !== cacheText) {
      cacheText = node.textContent;
      cacheVal = null;
      try {
        var d = JSON.parse(cacheText);
        if (d && d.length === 4) {
          cacheVal = {
            ids: d[0].map(String), colorOf: d[1], media: d[2], always: d[3],
            sectionId: node.id.slice(JSON_PREFIX.length)
          };
        }
      } catch (e) { cacheVal = null; }
    }
    return cacheVal;
  }

  function findRoot(d) {
    if (d) {
      var r = document.getElementById('shopify-section-' + d.sectionId);
      if (r) return r;
    }
    var c = document.querySelector('.product-image-container');
    return c ? (c.closest('.shopify-section') || document) : document;
  }

  function currentVariantId(root) {
    var i = root.querySelector('form[action*="/cart/add"] [name="id"]');
    if (i && i.value) return String(i.value).trim();
    var m = location.search.match(/[?&]variant=(\d+)/);
    return m ? m[1] : null;
  }

  function allowedKeys(d, vid) {
    if (!d || !vid) return null;
    var i = d.ids.indexOf(vid);
    if (i < 0) return null;
    var list = d.media[d.colorOf[i]];
    if (!list) return null;
    var set = Object.create(null), j;
    for (j = 0; j < list.length; j++) set[list[j]] = 1;
    for (j = 0; j < d.always.length; j++) set[d.always[j]] = 1;
    return set;
  }

  function setDisplay(el, want) {
    if (el.style.display !== want) el.style.display = want;
  }

  /* Tema tembel yuklemede src'yi width=20 basiyor. CDN'den daha buyugunu iste. */
  function thumbSrc(img) {
    if (!img) return '';
    var s = img.getAttribute('src') || '';
    if (!s || s.indexOf('data:') === 0) {
      var ss = img.getAttribute('srcset') || '';
      s = ss ? ss.split(',')[0].trim().split(/\s+/)[0] : '';
    }
    if (!s) return '';
    if (/[?&]width=\d+/.test(s)) return s.replace(/([?&]width=)\d+/, '$1' + THUMB_W);
    return s + (s.indexOf('?') > -1 ? '&' : '?') + 'width=' + THUMB_W;
  }

  function ensureRail(container) {
    var rail = container.querySelector(':scope > .cfg-rail');
    if (!rail) {
      rail = document.createElement('div');
      rail.className = 'cfg-rail';
      container.insertBefore(rail, container.firstChild);
    }
    return rail;
  }

  function buildRail(rail, slides) {
    var sig = slides.map(function (s) { return s.getAttribute('data-media-id'); }).join('|');
    if (rail.dataset.sig === sig) return;
    rail.dataset.sig = sig;
    rail.innerHTML = '';

    slides.forEach(function (slide) {
      var key = slide.getAttribute('data-media-id');
      var src = thumbSrc(slide.querySelector('img'));
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-key', key);
      b.setAttribute('aria-label', 'Görsel');
      if (src) {
        var t = document.createElement('img');
        t.src = src;
        t.alt = '';
        t.loading = 'lazy';
        b.appendChild(t);
      }
      b.addEventListener('click', function () { current = key; apply(); });
      rail.appendChild(b);
    });
  }

  function markSelected(rail) {
    var bs = rail.querySelectorAll('button');
    for (var i = 0; i < bs.length; i++) {
      var on = bs[i].getAttribute('data-key') === current;
      if (bs[i].classList.contains('cfg-sel') !== on) bs[i].classList.toggle('cfg-sel', on);
    }
  }

  function apply() {
    var d = getData();
    var root = findRoot(d);
    var container = root.querySelector ? root.querySelector('.product-image-container') : null;
    if (!container) return;

    var slider = container.querySelector('product-slider');
    if (!slider) return;

    var all = Array.prototype.slice.call(slider.querySelectorAll(SLIDE_SEL));
    if (!all.length) return;

    var allowed = allowedKeys(d, currentVariantId(root));
    var visible = allowed ? all.filter(function (s) {
      return allowed[s.getAttribute('data-media-id')];
    }) : all;
    if (!visible.length) visible = all;

    var desktop = window.matchMedia(DESKTOP).matches;
    var rail = ensureRail(container);
    if (!container.classList.contains('cfg-on')) container.classList.add('cfg-on');

    if (desktop) {
      var keys = visible.map(function (s) { return s.getAttribute('data-media-id'); });
      if (keys.indexOf(current) < 0) current = keys[0];

      all.forEach(function (s) {
        setDisplay(s, s.getAttribute('data-media-id') === current ? '' : 'none');
      });
      buildRail(rail, visible);
      markSelected(rail);
      setDisplay(rail, '');
    } else {
      var ok = Object.create(null);
      visible.forEach(function (s) { ok[s.getAttribute('data-media-id')] = 1; });
      all.forEach(function (s) {
        setDisplay(s, ok[s.getAttribute('data-media-id')] ? '' : 'none');
      });
      setDisplay(rail, 'none');
    }
  }

  window.cfGalleryDebug = function () {
    var d = getData();
    var root = findRoot(d);
    var container = root.querySelector ? root.querySelector('.product-image-container') : null;
    var slider = container && container.querySelector('product-slider');
    var all = slider ? slider.querySelectorAll(SLIDE_SEL).length : 0;
    var vid = currentVariantId(root);
    var allowed = allowedKeys(d, vid);
    return {
      json: d ? 'var' : 'YOK',
      sectionId: d ? d.sectionId : '-',
      varyant: vid,
      idDizisindeIndeks: (d && vid) ? d.ids.indexOf(vid) : '-',
      renkIndeksi: (d && vid && d.ids.indexOf(vid) > -1) ? d.colorOf[d.ids.indexOf(vid)] : '-',
      toplamSlayt: all,
      izinliMedya: allowed ? Object.keys(allowed).length : 'YOK (filtre uygulanmiyor)',
      sahnedeki: current,
      masaustu: window.matchMedia(DESKTOP).matches
    };
  };

  apply();
  document.addEventListener('DOMContentLoaded', apply);
  setInterval(apply, TICK_MS);
})();